import { render, staticRenderFns } from "./FAQDetail.vue?vue&type=template&id=6cd4b874&"
import script from "./FAQDetail.vue?vue&type=script&lang=js&"
export * from "./FAQDetail.vue?vue&type=script&lang=js&"
import style0 from "./FAQDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports